export default __webpack_public_path__ + "static/k12-section-1-img-e5603da07b144e74348bdcbd6bdfe130.png";